import { createStore, applyMiddleware, compose } from 'redux'
import thunkMiddleware from 'redux-thunk'
import reducer from './reducers'
import { composeWithDevTools } from 'redux-devtools-extension/logOnlyInProduction'
import createSentryMiddleware from "redux-sentry-middleware";
import * as Sentry from '@sentry/browser';

export default (initialState = {}) => {
  const sentryMiddleware = createSentryMiddleware(Sentry, {
    getUserContext: state => state.me
  })
  const middlewares = [thunkMiddleware, sentryMiddleware]
  if (process.env.NODE_ENV === 'development') {
    const { createLogger } = require('redux-logger')
    const logger = createLogger({
      predicate: (getState, action) => true
    })
    middlewares.push(logger)
  }

  const composeEnhancers = composeWithDevTools({
    // options like actionSanitizer, stateSanitizer
  })

  const store = createStore(reducer, initialState, composeEnhancers(
    applyMiddleware(...middlewares),
  ))

  if (process.env.NODE_ENV !== "production") {
    if (module.hot) {
      module.hot.accept('./reducers', () => {
        store.replaceReducer(reducer)
      })
    }
  }

  return store
}
